import Loading from '../../../../shared/Loading/Loading';
import Sort from './Sort';
import Card from './Card';

const List = ({
  loading,
  users,
  query,
  sortConfig,
  sortOptions,
  setSortColumn,
  toggleSortDirection,
  selected,
  isEliminator,
  isEditor,
  toggleOne,
  editUser,
  askDelete,
}) => {
  return (
    <div className="px-4 py-4 space-y-3 md:hidden">
      <Sort
        sortConfig={sortConfig}
        sortOptions={sortOptions}
        setSortColumn={setSortColumn}
        toggleSortDirection={toggleSortDirection}
      />
      {loading ? (
        <div className="flex justify-center py-10">
          <Loading size="28" colorBase="white" colorAccent="personalized" double={true} bold="8" />
        </div>
      ) : users.length === 0 ? (
        <div className="text-center text-sm text-gray-500 py-6">
          {query ? `No hay coincidencias para “${query}”` : 'No hay usuarios disponibles'}
        </div>
      ) : (
        users.map((user) => (
          <Card
            key={user.Id}
            user={user}
            isChecked={selected.has(user.Id)}
            isEliminator={isEliminator}
            isEditor={isEditor}
            toggleOne={toggleOne}
            editUser={editUser}
            askDelete={askDelete}
          />
        ))
      )}
    </div>
  );
};

export default List;
